<template>
  <div>
    <data-table
      title="Transfer Receiving Countries"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons"> </template>
      <template slot="item.is_sending_country" slot-scope="{ item }">
        <v-icon color="success" v-if="item.is_sending_country">
          mdi-progress-check
        </v-icon>
        <v-icon color="error" v-else>
          mdi-progress-close
        </v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isAdding: false,
      url: "/api/v1/transactions/transferReceivingCountries",
      headers: {
        "sending_country.name": "Sending Country",
        "sending_country.sending_min_amount": "Sending Min Amount",
        "sending_country.sending_max_amount": "Sending Max Amount",
        "receiving_country.name": "Receiving Country",
        "receiving_country.receiving_min_amount": "Receiving Min Amount",
        "receiving_country.receiving_max_amount": "Receiving Max Amount",
      },
      fields: {
        "sending_country.sending_min_amount": {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        "sending_country.sending_max_amount": {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        "receiving_country.receiving_min_amount": {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        "receiving_country.receiving_max_amount": {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    showDetails({ id }) {
      this.$router.push({ name: "platform.receivingCountries.show", params: { id } });
    },
  },
};
</script>
